const apis ={
    get_company: "/cuenta/usuario/empresa/",
    update_company: "/cuenta/usuario/actualizar/empresa",
    update_p12: "/cuenta/usuario/registro/certificado",
    put_update_pass: "/cuenta/usuario/contrasenia"
}

export default apis;